<template>
    <!-- *********************************************
    *                Top Informations                *
    ********************************************** -->
    <text-blocks-operation-info v-if="responseData" :params="operationInfoParams" />
    <!-- *********************************************
    *                  Account Block                 *
    ********************************************** -->
    <divider-generic
    dividerSize="medium"
    icon="account-balance"
    class="margin-top"
    :title="t('cards.charge.mcx.step3.dividerAccount')"/>
    <text-block-generic
    :params="textBlockAccountParams"
    :mask="ACCOUNT_NUMBER"/>
    <!-- *********************************************
    *                    Card Block                  *
    ********************************************** -->
    <divider-generic
    dividerSize="medium"
    icon="credit-card"
    :title="t('cards.charge.mcx.step3.dividerCard')"/>
    <text-block-generic
    :params="textBlockCardParams"/>
    <!-- *********************************************
    *                  Amount Block                  *
    ********************************************** -->
    <divider-generic
    dividerSize="medium"
    icon="bills"
    :title="t('cards.charge.mcx.step3.dividerAmount')"/>
    <text-block-generic
    :params="amountToChargeParams"/>
    <!-- *********************************************
    *         New Charge and Favorite Block          *
    ********************************************** -->
    <div class="button-block-wrapper">
        <div class="button-wrapper">
            <button-primary
            class="new-payment-button"
            icon="credit-card"
            iconPosition="right"
            :label="t('cards.charge.mcx.step3.newChargeButton')"
            @clicked="emit('newCharge')"/>
        </div>
    </div>
</template>

<script setup>
import DividerGeneric from '@/components/generic/dividers/Generic'
import TextBlockGeneric from '@/components/generic/textBlocks/Generic'
import ButtonPrimary from '@/components/generic/buttons/Primary'
import TextBlocksOperationInfo from '@/components/wrappers/OperationInfo'

/* Vue & Helpers */
import { ref, computed, onMounted } from 'vue'
import { amountFormat } from '@/assets/scripts/amounts'
import { ACCOUNT_NUMBER } from '@/assets/constants/masks'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['newCharge'])

const props = defineProps({
    getCards: Array,
    getAccountsBalances: Array,
    clearFormErrors: Boolean,
    formData: Object,
    mandatoryList: Array,
    showMandatoryErrors: Boolean,
    responseData: Object
})

const operationInfoParams = computed(() => {
    return {
        operationId: props.responseData.data.operationId,
        operationDate: props.responseData.data.creationDate,
        errorLevel: props.responseData.errorLevel
    }
})

const accountNumber = computed(() => {
    return props.getAccountsBalances.find(account => account.id === props.formData.originAccount).accountNumber
})

const textBlockAccountParams = ref({
    label: t('cards.charge.mcx.step3.account'),
    content: accountNumber.value
})

const cardNumber = computed(() => {
    return props.getCards.find(card => card.id === props.formData.originCard).cardNumber
})

const textBlockCardParams = ref({
    label: t('cards.charge.mcx.step3.card'),
    content: cardNumber.value
})

const amountToChargeParams = ref({
    label: t('cards.charge.mcx.step3.chargeAmount'),
    content: amountFormat(props.formData.amount, props.formData.currency)
})

onMounted(() => {
    emit('scrollTo', 0)
})
</script>

<style lang="scss" scoped>
.button-block-wrapper {
    .button-wrapper {
        width: 100%;

        display: flex;
        gap: 16px;

        .favorite-button {
            width: fit-content;
        }

        .new-payment-button {
            max-height: 48px;
        }
    }
}
</style>
